const { createConstant } = require("../../helpers");

const service = "market";

module.exports = {
  GET_FAVOURITES: createConstant(service, "GET_FAVOURITES"),
  GET_FAVOURITES_SUCCESS: createConstant(service, "GET_FAVOURITES_SUCCESS"),
  GET_FAVOURITES_ERROR: createConstant(service, "GET_FAVOURITES_ERROR"),
  GET_FAVOURITES_RESET: createConstant(service, "GET_FAVOURITES_RESET"),

  UPDATE_FAVOURITES: createConstant(service, "UPDATE_FAVOURITES"),
  UPDATE_FAVOURITES_SUCCESS: createConstant(
    service,
    "UPDATE_FAVOURITES_SUCCESS"
  ),
  UPDATE_FAVOURITES_ERROR: createConstant(service, "UPDATE_FAVOURITES_ERROR"),
  UPDATE_FAVOURITES_RESET: createConstant(service, "UPDATE_FAVOURITES_RESET"),
};
